import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from "lodash/isEmpty";
import { injectIntl, intlShape } from 'react-intl';
import FoodBeverageSection from './FoodBeverageSection';
import RestroomsSection from './RestroomsSection';
import AlcoholSection from './AlcoholSection';
import FurnitureSection from './FurnitureSection';
import EventActivitiesSection from './EventActivitiesSection';
import AVMusicSection from './AVMusicSection';
import EventRulesSection from './EventRulesSection';
import ParkingSection from './ParkingSection';
import HostRulesSection from './HostRulesSection';
import { displaySections } from './data/utils';

const EventFAQ = ({ faqData, parkingInfo = {}, hostRules = {}, intl })=> {
  return (
    <div>
      {displaySections.displayFoodBeverageSection(faqData) && <FoodBeverageSection faqData={faqData} />}
      {displaySections.displayAlcoholSection(faqData) && <AlcoholSection faqData={faqData} />}
      {displaySections.displayFurnitureSection(faqData) && <FurnitureSection faqData={faqData} />}
      {displaySections.displayRestroomSection(faqData) && <RestroomsSection faqData={faqData} />}
      {displaySections.displayAVMusicSection(faqData) && <AVMusicSection faqData={faqData} />}
      {displaySections.displayEventActivitiesSection(faqData) && <EventActivitiesSection faqData={faqData} />}
      {displaySections.displayEventRulesSection(faqData) && <EventRulesSection faqData={faqData} />}
      {!isEmpty(parkingInfo) && <ParkingSection parkingInfo={parkingInfo} intl={intl} />}
      {!isEmpty(hostRules) && <HostRulesSection hostRules={hostRules} intl={intl} />}
    </div>
  );
};

EventFAQ.propTypes = {
  faqData: PropTypes.object,
  intl: intlShape,
  parkingInfo: PropTypes.object,
  listingRules: PropTypes.object,
  hostRules: PropTypes.object
};

export default injectIntl(EventFAQ);
